import {
    ErrorResponse,
    QueryParams,
    ResponseArray,
    ResponseObject,
} from '@/types/shared'
import { Holiday } from '../types/response'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import datacentral from '@/utils/axios/datacentral'
import qs from 'query-string'
import {
    HolidayDeletePayload,
    HolidayDetailPayload,
    HolidayNewPayload,
    HolidayUpdatePayload,
} from '../types/payload'

export const getAllHoliday = async (
    payload: DataGridPayload
): Promise<ResponseArray<Holiday>> => {
    const response = await datacentral.get(
        `/workdays/holiday?${qs.stringify(payload)}`
    )
    return response.data
}

/** Get holidays list with sorting/pagination support */
export const getHolidayList = async (
    params: QueryParams
): Promise<ResponseArray<Holiday>> => {
    const response = await datacentral.get(
        `/workdays/holiday?${qs.stringify(params)}`
    )
    return response.data
}

export const createHoliday = async (
    payload: HolidayNewPayload
): Promise<ResponseObject<Holiday> | ErrorResponse> => {
    const response = await datacentral.post('/workdays/holiday', payload)
    return response.data
}

export const getHolidayById = async (payload: HolidayDetailPayload) => {
    const response = await datacentral.get<ResponseObject<Holiday>>(
        `/workdays/holiday/${payload.holiday_id}`
    )
    return response.data
}

export const updateHoliday = async (
    payload: HolidayUpdatePayload
): Promise<ResponseObject<Holiday> | ErrorResponse> => {
    const response = await datacentral.put(
        `/workdays/holiday/${payload.holiday_id}`,
        payload
    )
    return response.data
}

export const deleteHoliday = async (
    payload: HolidayDeletePayload
): Promise<ResponseObject<Holiday> | ErrorResponse> => {
    const response = await datacentral.delete(
        `/workdays/holiday/${payload.holiday_id}`
    )
    return response.data
}
